import {colors, createTheme} from "@mui/material";

export const appTheme = createTheme({
    palette: {
        primary: {
            main: colors.indigo[500]
        }
    }
});